import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { Row, Col } from 'react-bootstrap';
import About_Header from '../assets/images/About_header.png';
import story from '../assets/images/story.png'
import Eastridge from '../assets/images/Eastridge.png';
import deliver1 from '../assets/images/deliver1.png';
import deliver2 from '../assets/images/deliver2.png';
import '../../css/app.css';

const LearnMore = () => {
    return (
        <>
            <div className='about-us-header container' id='about-header'>
                <Row>
                    <Col md={6} className='about-us-header-content'>
                        <h1 style={{ fontSize: "65px", fontFamily: "Space Grotesk", fontWeight: "bold" }}>About DSSL & Our Passion for Lighting</h1>
                        <p style={{ fontSize: "18px", width: "70%" }}>We offer a customer experience unlike any other in the industry</p>
                    </Col>
                    <Col md={6}>
                        <img src={About_Header} alt="About-Header" />
                    </Col>
                </Row>
            </div>
            <div className='our-story' id="story">
                <div className='container'>
                    <h2 style={{ fontSize: "48px", fontWeight: "bold" }}>Our Story</h2>
                    <div className='our-story-body row'>
                        <div className='col-md-6'>
                            <img src={story} alt='our-story' />
                        </div>
                        <div className='col-md-6 our-story-contents'>
                            <p>Founded in 2016, DSSL is a fast-growing US-based lighting manufacturer providing high performance indoor and outdoor systems, as well as retrofit kits, to specifiers, lighting professionals and end-users.</p>
                            <p>Being a Nevada Department of Transportation certified Disadvantaged Business Enterprise and Minority Owned Business, DSSL is especially well-known for its customizing capabilities, one of the driving forces behind its growth.In 2021, DSSL expanded its offering with innovative designs and unique products to meet an increasing demand for specification grade lighting.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='vision'>
                <div className='container'>
                    <div className='vision-header row'>
                        <div className='col-md-4 d-flex flex-wrap'>
                            <h2>We Have</h2><h2 style={{ color: "#ccd62c" }}>&nbsp;Vision</h2>
                        </div>
                        <div className='col-md-8'>
                            <p>The DSSL customer experience goes far beyond purchasing a product. It’s first and foremost about cultivating relationships and engaging in open, constructive dialogue with our customers.</p>
                        </div>
                    </div>
                    <div className='vision-items row'>
                        <div className='col-md-4 vision-item'>
                            <p className='vision-item-title'>Community Spirit</p>
                            <p>We support locally sourced manufacturing and customizing initiatives to ensure sustainability, while fostering superior product quality and reliability.</p>
                        </div>
                        <div className='col-md-4 vision-item'>
                            <p className='vision-item-title'>Integrity</p>
                            <p>We are committed to conducting business ethically, fairly and transparently. We believe in equality and respect, both in and out of the workplace.</p>
                        </div>
                        <div className='col-md-4 vision-item'>
                            <p className='vision-item-title'>Collaboration</p>
                            <p>We address challenges using a collaborative, solution-oriented approach. Problem-solving is in our nature. We welcome customer input and work co-creatively towards reaching an optimal solution.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='versatility'>
                <div className='container versatility-container'>
                    <div className='d-flex versatility-header flex-wrap'>
                        <h2 style={{ fontSize: "18px" }}>We Embrace</h2><h2 style={{ color: "#ccd62c" }}>&nbsp;Versatility</h2>
                    </div>
                    <div className='versatility-contents row'>
                        <div className='col-md-6 pr-5'><p>We offer a wide variety of quality products and options, and are also capable of meeting the unique design requirements of our customers. Our ability to provide custom designs to scale, coupled with our manufacturing flexibility has set us apart from other importers and white label manufacturers.</p></div>
                        <div className='col-md-6 pl-5'><p>Today, we are moving forward and seeking growth opportunities in new markets. Our versatility now extends to the development of innovative and cost-efficient specification grade products designed to meet the higher quality standards of the commercial sector.</p></div>
                    </div>
                    <div className='east-image'>
                        <img src={Eastridge} alt="Eastridge" />
                        <span className='image-under mt-3'>EAST RIDGE MALL PROJECT — 2021</span>
                    </div>
                </div>
            </div>
            <div className='deliver-value container'>
                <Row>
                    <Col md={6} className='deliver-value-contents'>
                        <div className='d-flex flex-wrap'>
                            <h2 style={{ fontSize: "18px" }}>We Deliver</h2><h2 style={{ color: "#ccd62c" }}>&nbsp;Value</h2>
                        </div>
                        <p>
                            We always strive to do more for the customer. From product selection to shop drawings and design adjustments, all the way to shipping and after-sales, our promise translates into agile and responsive customer service.
                        </p>
                        <p>
                            However, our commitment to value goes beyond the realm of customer support. We also pride ourselves on providing affordably priced custom designs. This strategy has helped DSSL establish its strong market position based on our customizing capabilities.
                        </p>
                        <p>
                            We remain firmly committed to manufacturing reliable products with some of the lowest failure rates in the industry, while meeting the most stringent standards in terms of performance, energy savings and lighting quality.
                        </p>
                    </Col>
                    <Col md={6} className='deliver-value-image'>
                        <img src={deliver1} alt="deliver1" />
                        <img src={deliver2} alt="deliver2" className='mt-5' />
                    </Col>
                </Row>
            </div>
            <div className='about-us-question'>
                <div className='container questions' id='contact-us'>
                    <h2>Have Questions?</h2>
                    <div className='mt-5 row'>
                        <div className="col-md-6">
                            <input className="form-control" type="text" placeholder='Your Full Name' />
                        </div>
                        <div className="col-md-6">
                            <input className="form-control" type="email" placeholder='Your Full Name' />
                        </div>
                    </div>
                    <div className='mt-4'>
                        <input className="form-control" type="text" placeholder='Subject' />
                    </div>
                    <div className='mt-4'>
                        <textarea className="form-control" rows="5" placeholder='Your Message' />
                    </div>
                    <div className='mt-5'>
                        <button className='mt-4 send-question-btn'>SUBMIT MESSAGE <BsArrowRight style={{ marginLeft: "20px" }} /></button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LearnMore;